import { Menu, Text } from '@mantine/core';
import { Icon } from '@uag/react-core';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { ShortcutAction } from 'app/modules/wallforming/components/scenes/toolbar/types/shortcutAction';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const Cut = () => {
    const { t } = useTranslation();

    const { articleInstanceSelections, cutArticleInstances } = usePlacementStore(
        useShallow((state) => ({
            articleInstanceSelections: state.articleInstanceSelections,
            cutArticleInstances: state.cutArticleInstances
        }))
    );

    const hasSelection = (() => {
        for (const _ in articleInstanceSelections) {
            return true;
        }
        return false;
    })();

    return (
        <Menu.Item
            disabled={!hasSelection}
            leftSection={
                <Icon className="action-menu-entry-decoration action-menu-entry-decoration-icon" icon="content_cut" />
            }
            rightSection={
                <Text className="action-menu-entry-decoration-text text-right text-[13px]">{ShortcutAction.Cut}</Text>
            }
            onClick={() => cutArticleInstances()}
        >
            {t('labelCut')}
        </Menu.Item>
    );
};
